module.exports = __webpack_public_path__ + "static/img/bg-fr.88d65ce1.png";